import { useHistory } from 'react-router-dom';
import cn from 'classnames';
import { pathnames } from 'constants/pathnames';
import { Button } from 'components/Button';
import { Seo } from 'components/Seo';
import styles from 'pages/Services/TryAgain/TryAgain.scss';

export const TryAgain = () => {
  const { mainPage } = pathnames;
  const { push } = useHistory();

  return (
    <section className={styles.page}>
      <Seo title='Try Again' noindex />
      <div className={styles.wrapper}>
        <h1 className={styles.title}>Try that again</h1>
        <p className={styles.text}>Page could not be loaded. Please try again later.</p>
        <div className={styles.buttonsWrapper}>
          <Button className={styles.btn} text='Reload page' onClick={() => window.location.reload()} normalStyle />
          <Button className={cn(styles.btn, styles.mainPageBtn)} text='Try later' onClick={() => push(mainPage)} />
        </div>
      </div>
    </section>
  );
};
